import { FeedbackTray, RoadmapTray } from '@/components';
import { Icon } from '@/components/atoms';
import AccountProfileTray from '@/components/molecules/AccountProfile/AccountProfileTray';
import { TrayNavigationProvider } from '@/components/providers/common/TrayNavigationProvider';
import APP_CONFIG from '@/config/app';
import { FC, useState } from 'react';
import { GoMail } from 'react-icons/go';
import { SlUser } from 'react-icons/sl';
import { TbFlag3 } from 'react-icons/tb';
const FeedbackIcon = GoMail as React.ComponentType<any>;
const RoadmapIcon = TbFlag3 as React.ComponentType<any>;
const ProfileIcon = SlUser as React.ComponentType<any>;
interface AppTopNavigationBarProps {
  logout: () => void;
  goToHomePage: () => void;
}
const AppTopNavigationBar: FC<AppTopNavigationBarProps> = ({
  logout,
  goToHomePage,
}) => {
  const [isAccountTrayOpen, setIsAccountTrayOpen] = useState(false);
  const [isFeedbackTrayOpen, setIsFeedbackTrayOpen] = useState(false);
  const [isRoadmapTrayOpen, setIsRoadmapTrayOpen] = useState(false);
  return (
    <nav className="relative flex items-center justify-between w-full">
      <div onClick={goToHomePage} className="cursor-pointer">
        <Icon name="logo" intent={'accent'} />
      </div>
      <div className="flex items-center gap-md">
        {APP_CONFIG.SHOW_ROADMAP_BUTTON && (
          <div
            className="cursor-pointer text-accent flex items-center"
            onClick={() => setIsRoadmapTrayOpen(true)}
          >
            <RoadmapIcon size={20} />
          </div>
        )}
        <div
          className="cursor-pointer text-accent flex items-center"
          onClick={() => setIsFeedbackTrayOpen(true)}
        >
          <FeedbackIcon size={20} />
        </div>
        <div
          className="cursor-pointer text-accent flex items-center"
          onClick={() => setIsAccountTrayOpen(true)}
        >
          <ProfileIcon size={16} />
        </div>
      </div>
      <AccountProfileTray
        isTrayOpen={isAccountTrayOpen}
        setIsTrayOpen={setIsAccountTrayOpen}
        logout={logout}
      />
      <TrayNavigationProvider>
        <FeedbackTray
          isOpen={isFeedbackTrayOpen}
          onClose={() => setIsFeedbackTrayOpen(false)}
        />
        <RoadmapTray
          isOpen={isRoadmapTrayOpen}
          onClose={() => setIsRoadmapTrayOpen(false)}
        />
      </TrayNavigationProvider>
    </nav>
  );
};
export default AppTopNavigationBar;
